import React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'

const Title = () => {
  const { form } = useFormProvider()

  const { title } = form.values

  if (!title?.trim()) {
    return (
      <Text.Header1 weight="semibold" color="grey100">
        {i18n.t('processes.process_settings.wizard.title.placeholder')}
      </Text.Header1>
    )
  }

  return <Text.Header1 weight="semibold">{title}</Text.Header1>
}

export default Title
